module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"BELGELER","docCountColumn":"Doküman Sayısı"},"en":{"title":"DOCUMENTS","docCountColumn":"Documents"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Doc/Files/Summary.vue
// module id = cGBr
// module chunks = 1